/*
 * @author: 邓丽丹
 * @description: 切换新版本的域名
 */
import { APP_MODE } from 'ice';

const protocolStr = document.location.protocol;

const ACMS_URLS = {
  dev: `${protocolStr}//acms.test.i4px.com/`,
  test: `${protocolStr}//acms.test.i4px.com/`,
  stage: `${protocolStr}//acms-pre.i4px.com/`,
  prod: `${protocolStr}//acms.i4px.com/`,
  us: `${protocolStr}//acms.us.i4px.com/`,
  eu: `${protocolStr}//acms.eu.i4px.com/`,
  asia: `${protocolStr}//acms.asia.i4px.com/`,
  au: `${protocolStr}//acms.au.i4px.com/`,
};

/**
 * @description 网关请求地址
 */
const ACMS_URL = ACMS_URLS[APP_MODE];

export { ACMS_URL };
